import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { css } from "styled-components";
import DatePicker from "react-datepicker";
import DarkBackground from '../../../Common/backgroundLoader';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'





var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;
const Heading = [['Trip Id', 'Subsequent STO Number', 'PO Number',  'Warehouse',  'Client','Bill Number', 'Brand',  'Retailer Code',  'Item Code',  'MRP',  'Dispatch Quantity',  'Return Total', 'Return Good',  'Return Damage','Return Missing'  ,'SRN Date','Invoice No','Putaway Qty', 'Dues Qty','Gr push status','Gr Push Msg',
]];






class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchInventoryData = this.fetchInventoryData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      status: "",
      status_label: "",
      loading: false,

      isLoading: true,
      showFetchBinData: false,
      show_process_data: true,

      from_date: "",
      to_date: "",

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      orderData :[],
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      fromDateError: ""


    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  
  handleChange = (e)=>{
    const selectedIndex = e.target.selectedIndex;
    const selectedLabel = e.target.options[selectedIndex].text;
    this.setState({
      status: e.target.value,
      status_label: selectedLabel
    })
  }
  

  fetchInventoryData() {

    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })

    const payload = {
      status_id: this.state.status,
     
    };
    API.post('/utility/picker/view/', { param: payload })
      .then(response => response.data)

      .then(data => {

        console.log(data);
        this.setState({
           tableRows: this.assemblePosts(data.pickers),
          

        })

      })

      .then(async () => {

        this.setState({  isLoading: false })

       

      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData});
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      
        this.setState({
          filtered_orderData: value,
        });
      }
    };
  downloadReport = () => {
    //this.setState({loading:true})
    const payload = {
      location: this.state.selectedLocation,
      fromdate: From_Date_val,
      todate: to_Date_val,
      request_type: "download"
    };

    API.post('/reports/salesreturnreports/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          loading: false
        });

        window.location.href = data.data[0]
      })
      .catch(function (error) { });
  };

  assemblePosts = (data) => {

    let posts = data.map((post) => {
      var status = ""
      if (post.status == true) {
        status = "Active"
      } else { status = " Not Active" }
      return (

        {
          user_id: post.user_id,
          picker: post.picker,
          current_status: post.current_status,
          paused_reason: post.paused_reason,
          assign_order: post.assign_order,
          logged_at: post.logged_at,
          assign_times: post.assign_times,
          scanned_times: post.scanned_times,

         


        }

      )

    });

    this.setState({
      loading_overlay: false,
      posts: posts ,
      filtered_orderData : posts,
      orderData : posts,
    })

    return posts;

  }

  processData() {

    this.setState({
      loading: true
    })

  }

  render() {


    const data = {

      columns: [
        {
          label: 'Picker ID',
          field: 'user_id',
          sort: 'asc',
          width: 130,

        },
        {
          label: 'Picker Name',
          field: 'picker',
          sort: 'asc',
          width: 190,

        },
        {
          label: 'Status',
          field: 'current_status',
          sort: 'asc',
          width: 160,

        },
        {
          label: ' Reason',
          field: 'paused_reason',
          sort: 'asc',
          width: 160,

        },
        {
          label: 'Assigned Order',
          field: 'assign_order',
          sort: 'asc',
          width: 160,

        },
        {
          label: 'Current Log',
          field: 'logged_at',
          sort: 'asc',
          width: 160,

        },

        {
          label: 'Assigned Time',
          field: 'assign_times',
          sort: 'asc',
          width: 160,

        },
       
        {
          label: 'Scanning Started Time',
          field: 'scanned_times',
          sort: 'asc',
          width: 190,

        },
       
       

       


      ],

      rows: this.state.tableRows,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
        <Overlay>
              <form className="form">
                <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                  <span className="filter_title">Filters</span>
                </div>
                <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                  <span className="date_title">Select Status</span>
                  <div style={{ position: 'relative' }}>
                     <select
                      className="form-control"
                      style={{ fontSize: 13,}}
                      onChange={this.handleChange}
                    // name="year"               
                    >
                      <option value="">Select Status</option>
                      <option value="1">Logged In</option>
                      <option value="3">Paused </option>
                      <option value="4">Logged Out </option>
                    </select>
                   
                  </div>
                </div>

               

             <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
              <ButtonToolbar className="form__button-toolbar">
                <Button
                  className="btn-sm button_enable1 "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                    marginRight: '10px',
                  }}
                  id="button_view"
                  onClick={() => this.fetchInventoryData()}
                >
                  {this.state.loading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  View
                </Button>
             
                <Button
                  type="button"
                  className="btn btn-primary-outline"
                  style={{
                      cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                      backgroundColor: '#FFFFFF',
                      padding: "5px 10px",
                      color: '#333333', // Set text color
                      display: 'flex',   // Use flexbox to align image and text
                      alignItems: 'center' // Center items vertically
                  }}
                  id="button_download"
                   onClick={(e) => exportToCSV(this.state.filtered_orderData, "Sales Return Report", Heading)}>
                  <img
                      src={DownloadIcon}
                      alt="Download"
                      style={{ width: '22px' }} // Adjust size as needed
                  />
                  Download
                </Button>
              </ButtonToolbar>
            </div>

          </form>
          </Overlay>
          {!this.state.showFetchBinData && (
            <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
               <img style={{width: '10%'}} src={EmptyDataIcon} />
                <p className="noDataTextStyle">
                Choose your filters from the available options. The data will display
              </p>
              <p className="noDataTextStyle2">
                 here once the filters have been applied.
              </p>
            </div>
          )}

          {
            this.state.showFetchBinData && (

                <div>
            <div>
                {this.state.status &&
                <div className="date-container">
                 {this.state.status_label}
                </div>
                }



              </div>
            <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -27 }}
              >
                 <span
                    className="pull-right"
                    onClick={() => this.fetchInventoryData()}
                    style={{
                      fontSize: "17px",
                      paddingRight: "45px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "28px",
                    }}
                  >
                    <FontAwesomeIcon icon={faSyncAlt}></FontAwesomeIcon>
                  </span>
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  sortable={false}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'Sales Return Report', 'datatable_pagination_change' )}
                  hover
                  onSearch={this.filterData}
                  data={data}
                  // style={{ textAlign: "center" }}
                />
             </div>
            </div>
            </div>

            )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));